import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ForBusinesses from './pages/ForBusinesses';
import ContactBookDemo from './pages/ContactBookDemo';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CommunityGuidelines from './pages/CommunityGuidelines';
import AccountDeletion from './pages/AccountDeletion';
import Profile from './pages/Profile';
import Hotspot from './pages/Hotspot';
import Invite from './pages/Invite';
import Broadcast from './pages/Broadcast';

function App() {
  return (
    <div className="App">
      <div className="App-content">
        <Router>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/for-businesses" element={<ForBusinesses />} />
              <Route path="/contact" element={<ContactBookDemo />} />
              <Route path="/terms" element={<TermsAndConditions />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/community-guidelines" element={<CommunityGuidelines />} />
              <Route path="/account-deletion" element={<AccountDeletion />} />
              <Route path="/profile/user/:userId" element={<Profile />} />
              <Route path="/profile/:userId" element={<Profile />} />
              <Route path="/Hotspot/:hotspotId" element={<Hotspot />} />
              <Route path="/Hotspot/broadcast/:broadcastId" element={<Broadcast />} />
              <Route path="/invite/:inviteId" element={<Invite />} />
              <Route path="/broadcast/:broadcastId" element={<Broadcast />} />
            </Routes>
          </main>
          <Footer />
        </Router>
      </div>
    </div>
  );
}

export default App; 